module.exports = __webpack_public_path__ + "img/Mstorybg9.a043eeb8.jpg";